import {IStorageService} from '../../../app-react/services/storage/storage.service.interface';
import {Check} from '@sparkware/app-utils';

export function saveLauncherConfigOverrides(clientData: any, storage: IStorageService): void {
    if(Check.isEmpty(clientData)) {
        storage.removeItem('cgp_client');
    } else {
        storage.setJson('cgp_client', {
            clientData: clientData
        });
    }
}